import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Button, Input, Row, Col } from 'react-bootstrap'
import autobind from 'autobind-decorator'
import { Icon } from 'react-fa'
// this component is used as navigation buttons bar in the bottom in results, guestentry and payment page.
@autobind
export default class BottomNavigationButtons extends Component {
  static propTypes = {
    customClass: PropTypes.string,
    showBack: PropTypes.bool,
    nextCB: PropTypes.func,
    backCB: PropTypes.func
  }

  render() {
    let {
      showBack,
      showNext,
      handleSubmit,
      customClass,
      nextCB,
      backCB,
      nextLabel
    } = this.props

    return (
      <Row className={(customClass || '') + ' nav-buttons-top'}>
        <div className='nav-buttons-bar nav-buttons'>
          <div className='container'>
            <Row className='nav-padder'>
              {showBack ? (
                <Col className='back-button' md={1} lg={1} sm={3} xs={1}>
                  <Button type='button' bsStyle='primary' onClick={backCB}>
                    {' '}
                    <Icon size='lg' name='angle-left' /> Back
                  </Button>
                </Col>
              ) : null}

              {showNext ? (
                <Col
                  className='next-button pull-right'
                  lg={2}
                  md={1}
                  sm={2}
                  xs={3}
                >
                  <Button
                    type='button'
                    className='pull-right'
                    bsStyle='primary'
                    onClick={nextCB}
                  >
                    {nextLabel || 'Next'} <Icon size='lg' name='angle-right' />
                  </Button>
                </Col>
              ) : null}
            </Row>
          </div>
        </div>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/bottomNavigationButtons.js